<!-- 答题中的解析页面容器 -->
<template>
  <div class="container">
    <Head></Head>
    <div class="Box">
      <div class="tabBox">
        <div class="quseBox">
          <div class="questions">
            <div class="currhead">
              <!-- 当前课程 -->
              <h1 class="currh1">{{courseName}}</h1>
              <div @click="slices" class="currfont" style="cursor: pointer;">
                返回
                <img alt src="@/assets/img/slices/slices.png" style="margin-left: 10px;" />
              </div>
            </div>
            <div class="titcent">
              <!-- 当前试卷 -->
              <img alt src="@/assets/img/icon.png" />
              {{ExaminationInfo.examinationName}}解析
            </div>
            <div>
              <div class="question_box better-scroll-bar">
                <div
                  :id="'parsing' + item.examinationItemId"
                  :key="item.examinationItemId"
                  v-for="item in showItemList"
                >
                  <!-- 单选题 -->
                  <RadioTopics
                    :bankData="item"
                    :courseId="courseId"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'单选题'"
                    v-if="Number(item.questionType) === 1"
                    v-on:setCollect="setCollect"
                  ></RadioTopics>
                  <!-- 多选题 -->
                  <CheckboxTopics
                    :courseId="courseId"
                    :examinationItemData="item"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'多选题'"
                    v-else-if="Number(item.questionType) === 2"
                    v-on:setCollect="setCollect"
                  ></CheckboxTopics>
                  <!-- 判断题 -->
                  <RadioTopics
                    :bankData="item"
                    :courseId="courseId"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'判断题'"
                    v-else-if="Number(item.questionType) === 3"
                    v-on:setCollect="setCollect"
                  ></RadioTopics>
                  <!-- 简答题 -->
                  <TextTopics
                    :bankData="item"
                    :courseId="courseId"
                    :topTypeId="ExaminationInfo.topTypeId"
                    :typeText="'简答题'"
                    v-else-if="Number(item.questionType) === 4"
                    v-on:setCollect="setCollect"
                  ></TextTopics>
                </div>
              </div>
            </div>
          </div>
          <div class="answerSheet">
            <!-- 右侧列表 -->
            <ProblemControlers
              :count="numCount"
              :numCount="num"
              :selectData="dataAll"
              v-on:submitAnswer="submitAnswer"
            ></ProblemControlers>
          </div>
        </div>
        <div class="question_page">
          <el-pagination
            :current-page.sync="page"
            :next-text="`下一页`"
            :page-size="5"
            :prev-text="`上一页`"
            :total="count"
            @current-change="handleCurrentChange"
            layout="prev, next"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/pc/Head'
import ProblemControlers from '@/components/pc/questionBank/ProblemControlers'
import RadioTopics from '@/components/pc/questionBank/RadioTopics'
import CheckboxTopics from '@/components/pc/questionBank/CheckboxTopics'
import TextTopics from '@/components/pc/questionBank/TextTopics'
import * as QUESTION_API from '@/api/ExaminationAPI'
export default {
  data () {
    return {
      selectCount: 0,
      showItemList: [],
      examinationId: '',         //题目id
      ExaminationInfo: {},
      courseName: '',
      itemCount: 0,                 //题目总数量
      examinationItemList: [],
      submitData: [],
      copyData: '',
      dataAll: '',
      activeName: 'first',
      initList: '',
      liData: '',
      page: 1,
      pagesize: 5,
      count: 0,
      date: '',
      isLeaval: false,
      numCount: 0,
      num: 0,
      numTime: 0,
      prePath: sessionStorage.getItem('prePath') || '',
      push_status: false,
      is_show: true,
      pushType: 2,
      courseId: 0,
    }
  },
  components: {
    ProblemControlers,
    RadioTopics,
    CheckboxTopics,
    TextTopics,
    Head
  },
  computed: {},
  beforeRouteEnter (to, from, next) {
    //  这里的vm指的就是vue实例，可以用来当做this使用
    next(vm => {
      if (from.path.length > 2) {
        sessionStorage.setItem('prePath', from.path)
        vm.prePath = from.path
      }
    })
  },
  created () {
  //  console.log('从课程详细页面开始解析跳转此页面')
    //从课程详细页面开始解析跳转此页面
    if (this.$route.params.parsingObj) {
      this.examinationId = this.$route.params.examinationId
      this.courseName = this.$route.params.courseName
       this.courseId=this.$route.params.courseId
      this.ExaminationInfo = this.$route.params.examinationData
    } else {
      this.examinationId = JSON.parse(sessionStorage.getItem('parsing')).examinationId
      this.courseName = JSON.parse(sessionStorage.getItem('parsing')).courseName
      this.courseId=JSON.parse(sessionStorage.getItem('parsing')).courseId
      this.ExaminationInfo = JSON.parse(sessionStorage.getItem('parsing')).examinationData
    }
    console.log( this.courseId,'rrr')

    this.initData()
  },
  mounted () {
    window.addEventListener('setItem', e => {
      let active = ''
      if (e.key === 'active_an') {
        active = JSON.parse(sessionStorage.getItem('active_an'))
        this.page = Math.ceil(active.index / 5)
        this.showItemList = []
        this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
        setTimeout(() => {
          if (active.active) {
            // this.goTop(active.active)
          }
        }, 200)
      } else {
        console.log(e.key, '我在输出else')
      }
    })
  },
  watch: {
    numCount (val) {
      if (val > 0) {
        this.is_submit = false
      }
    }
  },
  methods: {
    getChildVal () { },
    submitAnswer () { },

    // 模拟答题卡数据
    initData () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let params = {
        examinationId: this.examinationId,
        type: 3,
        withTestLog: true,//查询用户答题数据需要字段
        withCollect: true,
        courseId: this.ExaminationInfo.courseId,
        channelNo: localStorage.getItem('c_no'),
      }
      //查询当前用户答题记录数据
      QUESTION_API.examinationItemList(params).then(res => {
        loading.close();
        console.log('查询当前用户答题记录数据')
        if (res && Number(res.code) === 0) {
          this.examinationItemList = res.data;
          this.itemCount = this.examinationItemList.length
          this.count = res.data.length
          let data = []
          for (let i = 0; i < this.examinationItemList.length; i++) {
            this.submitData[i] = {}
            this.submitData[i].examinationItemId = this.examinationItemList[i].examinationItemId
            this.submitData[i].questionType = this.examinationItemList[i].questionType
            this.submitData[i].questionAnswer = this.examinationItemList[i].questionAnswer
            this.submitData[i].select = ''
            data[i] = this.examinationItemList[i]
            data[i].order = (i + 1)

          }
          this.dataAll = data
          this.copyData = data
          this.showItemList = this.dataAll.slice((this.page - 1) * this.pagesize, this.page * this.pagesize)
        } else {
          this.dataAll = []
          this.copyData = []
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },
    slices () {
      this.$router.back()
    },

    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.page = val
      this.showItemList = []
      this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
    },
    // goTop(el) {
    //   document.querySelector(el).scrollIntoView(true)
    // },

    //题目中收藏按钮点击回调事件
    setCollect (obj) {
      console.log(444444)
      console.log(obj.push)
      if (obj.push) {
        for (let i = 0; i < this.dataAll.length; i++) {
          if (Number(obj.examinationItemId) === Number(this.dataAll[i].examinationItemId)) {
            this.dataAll[i].isCollect = obj.collect
          }
        }
        this.dataAll = this.copyData
        this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
      }
    },

    // 答题卡查看全部和只看错题的回调
    setBankList (val) {
      this.page = 1
      if (val > 0) {
        let arr = []
        for (let i = 0; i < this.copyData.length; i++) {
          if (!this.copyData[i].isCorrect) {
            arr.push(this.copyData[i])
          }
        }
        for (let i = 0; i < arr.length; i++) {
          arr[i].order_size = (i + 1)
        }
        this.dataAll = JSON.parse(JSON.stringify(arr))
      } else {
        this.dataAll = JSON.parse(JSON.stringify(this.copyData))
      }
      this.itemCount = this.dataAll.length
      this.showItemList = this.dataAll.slice(Number((this.page - 1) * this.pagesize), Number(this.page * this.pagesize))
    },

  },
  beforeRouteLeave (to, form, next) {
    next()
  },
  destroyed () {
    sessionStorage.removeItem('prePath')
  }
}
</script>
<style scoped>
.question_box {
  height: 500px;
  overflow: auto;
}
.titcent {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
}
.titcent img {
  margin-right: 16px;
}
.currhead {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.currh1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 64px;
}
.quseBox {
  display: flex;
  justify-content: space-between;
}
.questions {
  width: 844px;
  height: 780px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 40px;
}
.answerSheet {
  width: 425px;
  height: 780px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
.tabBox {
  max-width: 1282px;
  margin: 0 auto;
  margin-top: 30px;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0px;
}
::v-deep .el-pagination button:disabled {
  margin-right: 10px;
}
::v-deep .el-pagination {
  margin: 20px 0;
}
</style>